const navLinks = [
  {
    id: 0,
    page: "home",
    path: "#home",
  },
  {
    id: 1,
    page: "about",
    path: "#about",
  },
  {
    id: 2,
    page: "projects",
    path: "#projects",
  },
  {
    id: 3,
    page: "contact",
    path: "#contact",
  },
];


export {navLinks}